export const cardTokens = {
  'card-bg': 'var(--dp-color-background)',
  'card-border-color': 'var(--dp-color-border)',
  'card-border-radius': 'var(--dp-border-radius-lg)',
  'card-shadow': 'var(--dp-shadow-sm)',
  'card-padding': 'var(--dp-spacing-lg)',
  'card-hover-shadow': 'var(--dp-shadow-md)',
  'card-hover-border-color': 'var(--dp-color-border-strong)',
  'card-header-padding': 'var(--dp-spacing-lg)',
  'card-footer-padding': 'var(--dp-spacing-lg)',
  'card-footer-bg': 'var(--dp-color-surface)',
} as const;
